import * as React from 'react';
const OrderIcon = props => (
  <svg
    aria-hidden="true"
    viewBox="0 0 128 128"
    xmlns="http://www.w3.org/2000/svg"
    data-name="OrderIcon"
    {...props}
  >
    <path
      strokeWidth={0}
      d="M19,118.14c-.05.05-.11.1-.17.14-.03.02-.06.03-.09.05-.03.02-.07.04-.1.05-.04.02-.08.02-.11.04-.03,0-.06.02-.09.03-.14.03-.29.03-.44,0-.03,0-.06-.02-.09-.03-.04-.01-.08-.02-.11-.04-.04-.02-.07-.04-.1-.06-.03-.02-.06-.03-.09-.05-.06-.04-.12-.09-.17-.14l-8.94-8.94c-.44-.44-.44-1.14,0-1.58.22-.22.5-.33.79-.33s.57.11.79.33l7.03,7.03v-16.86c0-.62.5-1.12,1.12-1.12s1.12.5,1.12,1.12v16.86s7.03-7.03,7.03-7.03c.22-.22.5-.33.79-.33s.57.11.79.33c.44.44.44,1.14,0,1.58l-8.94,8.94Z"
    />
    <path
      strokeWidth={0}
      d="M17.42,21.6c.05-.05.11-.1.17-.14.03-.02.06-.03.09-.05.03-.02.07-.04.1-.05.04-.02.08-.02.11-.04.03,0,.06-.02.09-.03.14-.03.29-.03.44,0,.03,0,.06.02.09.03.04.01.08.02.11.04.04.02.07.04.1.06.03.02.06.03.09.05.06.04.12.09.17.14l8.94,8.94c.44.44.44,1.14,0,1.58-.22.22-.5.33-.79.33s-.57-.11-.79-.33l-7.03-7.03v16.86c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12v-16.86s-7.03,7.03-7.03,7.03c-.22.22-.5.33-.79.33s-.57-.11-.79-.33c-.44-.44-.44-1.14,0-1.58l8.94-8.94Z"
    />
    <rect
      width={14.82}
      height={86}
      x={70.72}
      y={-13.43}
      strokeWidth={0}
      opacity={0.7}
      transform="translate(107.7 -48.56) rotate(90)"
    />
    <rect
      width={14.82}
      height={86}
      x={70.72}
      y={37.86}
      strokeWidth={0}
      opacity={0.7}
      transform="translate(158.98 2.73) rotate(90)"
    />
    <rect width={27.33} height={14.82} x={35.13} y={39.32} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={35.13} y={56.29} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={64.46} y={39.32} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={64.46} y={56.29} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={93.79} y={39.32} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={93.79} y={56.29} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={35.13} y={90.61} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={35.13} y={107.57} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={64.46} y={90.61} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={64.46} y={107.57} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={93.79} y={90.61} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={93.79} y={107.57} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={35.13} y={5} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={64.46} y={5} strokeWidth={0} />
    <rect width={27.33} height={14.82} x={93.79} y={5} strokeWidth={0} />
  </svg>
);
export default OrderIcon;
